module.exports = __webpack_public_path__ + "01290cc43ac2a66d6b41b6a5c93d6fee.MP3";